import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getUserRoles } from "api/user";
import { Roles, RolesDataResponse } from "models/roles";

export const useRoles = (options?: UseQueryOptions<RolesDataResponse, Error, Roles[]>) => {
	return useQuery<RolesDataResponse, Error, Roles[]>(['roles'], getUserRoles, options);
};